import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import Profile from '../../components/views/supporter/Profile'

function SupporterProfilePage(props) {
	if (props.role === TRoles.SUPPORTER) return <Profile />

	return <Redirect to={TRoutes.DASHBOARD} />
}

SupporterProfilePage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(SupporterProfilePage)
